// ¿Mostrar "Crear receta"? ¿Y qué pasa al tocarlo?
//
// Son DOS preguntas distintas y conviene no mezclarlas:
//
//   mostrar      quién tiene derecho a ver el botón. Un profesional de salud,
//                tenga o no la matrícula cargada. El botón escondido no
//                enseña nada: el médico nunca se entera de que puede recetar.
//   puedeEmitir  si ya puede emitir de verdad. Si no, el botón lleva a cargar
//                la matrícula, que es justamente el camino que queremos.
//
// QUIÉN NO LO VE, Y POR QUÉ NO ALCANZA CON EL TIPO DE PROFESIONAL
// ---------------------------------------------------------------
// La secretaria no receta: la receta la firma el médico con su matrícula.
// Pero cuando ella abre el calendario recibe `overrideUser` con los datos DEL
// PROFESIONAL, así que `professional_type` le dice 'salud' igual. Por eso la
// pregunta se hace sobre la cuenta con la que se inició sesión —la de
// localStorage— y no sobre el profesional que se está mirando.
//
// Estética tampoco: quien hace uñas no receta.

import { useEffect, useState } from 'react';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000';

let cache: boolean | null = null;
let enVuelo: Promise<boolean> | null = null;

/** La cuenta con la que se inició sesión, no la que se está mirando. */
function esProfesionalDeSalud(): boolean {
  try {
    const crudo = localStorage.getItem('user');
    if (!crudo) return false;
    const u = JSON.parse(crudo);
    return Boolean(u?.es_profesional) && u?.professional_type === 'salud';
  } catch {
    return false;
  }
}

async function consultar(): Promise<boolean> {
  const token = localStorage.getItem('token');
  if (!token) return false;
  try {
    const res = await fetch(`${API_URL}/api/prescriptions/eligibility`, {
      headers: { Authorization: `Bearer ${token}` },
    });
    if (!res.ok) return false;
    const json = await res.json();
    return Boolean(json?.puedeEmitir);
  } catch {
    return false;
  }
}

/** Limpia el cache. Se llama al cargar y al quitar la matrícula. */
export function olvidarHabilitacionRecetas() {
  cache = null;
  enVuelo = null;
}

export default function useRecetas(): { mostrar: boolean; puedeEmitir: boolean } {
  const [puedeEmitir, setPuedeEmitir] = useState<boolean>(cache ?? false);
  const mostrar = esProfesionalDeSalud();

  useEffect(() => {
    if (!mostrar) return;
    let vigente = true;
    if (cache !== null) {
      setPuedeEmitir(cache);
      return;
    }
    if (!enVuelo) enVuelo = consultar();
    enVuelo.then((r) => {
      cache = r;
      if (vigente) setPuedeEmitir(r);
    });
    return () => {
      vigente = false;
    };
  }, [mostrar]);

  return { mostrar, puedeEmitir };
}
